export const AddressMenu = {
  routes: [
    {
      name: 'clients',
      displayName: 'menu.clients',
      subject_class: 'Clients'
    },
    {
      name: 'localities',
      displayName: 'menu.localities',
      subject_class: 'Localities'
    },
  ]
} 

        
